export default __webpack_public_path__ + "static/fagdag-hero-9e32e3ed63e08b61d41fe683aae94be0.jpg";